var Queensland = "Queensland";
var Tasmania = "Tasmanie";
var Victoria = "Victoria";
var AUStates = {
	"Australian Capital Territory": "Territoire de la capitale australienne",
	"New South Wales": "Nouvelle-Galles du Sud",
	"Northern Territory": "Territoire du Nord",
	Queensland: Queensland,
	"South Australia": "Australie-Méridionale",
	Tasmania: Tasmania,
	Victoria: Victoria,
	"Western Australia": "Australie Occidentale"
};

export { Queensland, Tasmania, Victoria, AUStates as default };
